import { render, staticRenderFns } from "./timbreTool.vue?vue&type=template&id=7cb51dc2&scoped=true"
import script from "./timbreTool.vue?vue&type=script&lang=js"
export * from "./timbreTool.vue?vue&type=script&lang=js"
import style0 from "./timbreTool.vue?vue&type=style&index=0&id=7cb51dc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb51dc2",
  null
  
)

export default component.exports